import { Component, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CustomerService } from '../../../../../../../../../../services/customer/customer.service';
import { CustomerMembership } from '../../../../../../../../../../models/membership';
import { openClimberAppInNewTabAsCustomer } from '../../../../../../../../../../utils-models';
import { OrganizationConfigService } from '../../../../../../../../../../services/organization-config/organization-config.service';

@Component({
  selector: 'app-edit-recurring-customer-membership-purchase-upfront-payment-option',
  templateUrl: './edit-recurring-customer-membership-purchase-upfront-payment-option.component.html',
  styleUrls: ['./edit-recurring-customer-membership-purchase-upfront-payment-option.component.css']
})
export class EditRecurringCustomerMembershipPurchaseUpfrontPaymentOptionComponent implements OnInit, OnDestroy {

  @Input() membership: CustomerMembership;
  @Input() savedCallback: (successMessage: string) => undefined;
  @Input() saveClickedObservable: Observable<void>;
  @Output() loadingEvent = new EventEmitter<boolean>();
  @Output() serverErrorEvent = new EventEmitter<number>();

  public errorMessage = '';

  private saveClickedSubscription: Subscription;

  constructor(
    private activeModal: NgbActiveModal,
    private orgService: OrganizationConfigService,
    private customerService: CustomerService
  ) {}

  ngOnInit() {
    this.saveClickedSubscription = this.saveClickedObservable.subscribe(() => {
      this.handleSave();
    });
  }

  ngOnDestroy() {
    this.saveClickedSubscription.unsubscribe();
  }

  private handleSave() {
    this.loadingEvent.emit(true);

    this.customerService
      .getCustomerClimberAppToken(this.membership.owner_id)
      .then(token => {
        const baseUrl = this.orgService.getOrganizationConfig().climber_app_base_url;
        openClimberAppInNewTabAsCustomer(
          token,
          this.membership.owner_id,
          baseUrl,
          baseUrl + 'membership/purchase-upfront-payment-option/' + this.membership.id.toString() + '/'
        );
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to manage this membership.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverErrorEvent.emit(reason.status);
        }
      })
      .finally(() => { this.loadingEvent.emit(false); });
  }

}
